import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { getAccessList } from '../../../../../repository';
import { GET_ACCESS_LIST } from '../../../../../store/actions';

const useAccessList = (userId, role, filterInactive) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    const query = useQuery({
        queryKey: ['access-list', userId, role, filterInactive],
        queryFn: async () => {
            const payload = await getAccessList(userId, role, filterInactive);
            dispatch({ type: GET_ACCESS_LIST, payload });
            return payload;
        },
        enabled: !!userId && role && role !== 'guest',
    });
    const clearAccessList = () => queryClient.removeQueries(['access-list', userId]);
    return { ...query, clearAccessList };
};

export default useAccessList;
